import { useState, useEffect, useCallback } from 'react';

var API = 'https://api.algrok.com';

function fmtINR(n) {
  if (n == null || isNaN(n)) return '--';
  var sign = n < 0 ? '\u2212' : '+';
  return sign + '\u20b9' + Math.abs(n).toLocaleString('en-IN', { maximumFractionDigits: 0 });
}

function StatBox(props) {
  return (
    <div style={{ flex: 1, minWidth: 92, background: '#0a0f1c', border: '1px solid #1f2937', borderRadius: 10, padding: '8px 12px', textAlign: 'center' }}>
      <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: 0.8, color: '#556677' }}>{props.label}</div>
      <div style={{ fontSize: 18, fontWeight: 800, color: props.color || '#e5e7eb', marginTop: 2 }}>{props.value}</div>
      {props.sub ? <div style={{ fontSize: 9, color: '#6b7a8d', marginTop: 1 }}>{props.sub}</div> : null}
    </div>
  );
}

function Field(props) {
  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: 3, minWidth: 132, flex: 1 }}>
      <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: 0.6, color: '#556677' }}>{props.label}</span>
      <input value={props.value == null ? '' : props.value} onChange={props.onChange}
        style={{ background: '#0d1524', border: '1px solid #26334a', borderRadius: 6, color: '#e5e7eb', fontSize: 12, padding: '6px 9px', fontFamily: 'inherit' }} />
    </label>
  );
}

var cardBase = { background: '#0a0f1c', border: '1px solid #1f2937', borderRadius: 12, padding: '12px 14px' };

var OIRideDLive = function () {
  var [st, setSt] = useState({});
  var [cfgOpen, setCfgOpen] = useState(false);
  var [draft, setDraft] = useState({});
  var [busy, setBusy] = useState(false);
  var [err, setErr] = useState('');

  var load = useCallback(function () {
    fetch(API + '/oiride-d-live/state').then(function (r) { return r.json(); })
      .then(function (d) { setSt(d || {}); setErr((d && d.error) || ''); })
      .catch(function () { setErr('unreachable'); });
  }, []);

  useEffect(function () {
    load();
    var id = setInterval(load, 5000);
    return function () { clearInterval(id); };
  }, [load]);

  function post(path, body) {
    setBusy(true);
    fetch(API + path, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body || {}),
    }).then(function (r) { return r.json(); })
      .then(function () { setBusy(false); load(); })
      .catch(function () { setBusy(false); });
  }

  var cfg = st.config || {};
  var legs = st.legs || [];
  var openLegs = legs.filter(function (l) { return l.status === 'open'; });
  var sig = st.signal || {};
  var enabled = !!st.enabled;
  var total = st.total_pnl || 0;
  var halt = st.halt_reason || '';

  function openCfg() {
    setDraft({
      lots: cfg.lots != null ? cfg.lots : 1,
      product: cfg.product || 'MIS',
      entry_time: cfg.entry_time || '09:17',
      exit_time: cfg.exit_time || '15:25',
      check_interval_sec: cfg.check_interval_sec != null ? cfg.check_interval_sec : 30,
      threshold_pct: cfg.threshold_pct != null ? cfg.threshold_pct : 10,
      confirm_checks: cfg.confirm_checks != null ? cfg.confirm_checks : 2,
      strikes_band: cfg.strikes_band != null ? cfg.strikes_band : 20,
      hedge_offset_normal: cfg.hedge_offset_normal != null ? cfg.hedge_offset_normal : 2,
      hedge_offset_expiry: cfg.hedge_offset_expiry != null ? cfg.hedge_offset_expiry : 1,
      mtm_sl_per_lot: cfg.mtm_sl_per_lot || 0,
      target_per_lot: cfg.target_per_lot || 0,
      protect_per_lot: cfg.protect_per_lot || 0,
      protect_level_per_lot: cfg.protect_level_per_lot || 0,
      trail_step_per_lot: cfg.trail_step_per_lot || 0,
    });
    setCfgOpen(true);
  }
  function D(k) {
    return function (e) {
      var v = e.target.value;
      setDraft(function (p) { var n = Object.assign({}, p); n[k] = v; return n; });
    };
  }
  function saveCfg() {
    var out = {};
    Object.keys(draft).forEach(function (k) {
      var v = draft[k];
      if (k === 'product' || k === 'entry_time' || k === 'exit_time') { out[k] = v; }
      else { var n = parseFloat(v); out[k] = isNaN(n) ? 0 : n; }
    });
    post('/oiride-d-live/config', out);
    setCfgOpen(false);
  }

  var dirColor = st.direction === 'LONG' ? '#22c55e' : st.direction === 'SHORT' ? '#ef4444' : '#6b7a8d';

  return (
    <div style={{ padding: '18px 22px', color: '#e5e7eb', fontFamily: 'inherit', maxWidth: 1400 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', marginBottom: 4 }}>
        <span style={{ fontSize: 22, fontWeight: 800 }}>🎯 OI Ride D LIVE</span>
        <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, padding: '3px 8px', borderRadius: 6, background: 'rgba(167,139,250,0.14)', color: '#a78bfa', border: '1px solid rgba(167,139,250,0.4)' }}>
          REVERSED · FADES SIGNAL
        </span>
        <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, padding: '3px 8px', borderRadius: 6, background: 'rgba(239,68,68,0.14)', color: '#ef4444', border: '1px solid rgba(239,68,68,0.4)' }}>
          REAL MONEY
        </span>

        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1, color: enabled ? '#22c55e' : '#6b7a8d' }}>
            {enabled ? '\u25cf ENABLED' : '\u25cb DISABLED'}
          </span>
          {/* Simple toggle, no confirmation — the bought wing caps the risk. */}
          <button onClick={function () { post(enabled ? '/oiride-d-live/disable' : '/oiride-d-live/enable'); }}
            disabled={busy}
            style={{
              fontSize: 11, fontWeight: 800, cursor: busy ? 'wait' : 'pointer', fontFamily: 'inherit',
              borderRadius: 8, padding: '7px 18px',
              background: enabled ? 'rgba(239,68,68,0.12)' : 'rgba(34,197,94,0.12)',
              color: enabled ? '#ef4444' : '#22c55e',
              border: '1px solid ' + (enabled ? 'rgba(239,68,68,0.5)' : 'rgba(34,197,94,0.5)'),
            }}>
            {enabled ? 'Disable' : 'Enable'}
          </button>
          <button onClick={openCfg}
            style={{ fontSize: 11, fontWeight: 800, cursor: 'pointer', background: 'transparent', color: '#8b98a9', border: '1px solid #1f2937', borderRadius: 8, padding: '7px 14px', fontFamily: 'inherit' }}>⚙</button>
        </div>
      </div>

      <div style={{ fontSize: 10, color: '#6b7a8d', marginBottom: 12 }}>
        NIFTY · {cfg.lots || 1}L · {cfg.product || 'MIS'} · entry {cfg.entry_time || '09:17'} · exit {cfg.exit_time || '15:25'} ·
        {' '}SELLS ATM, BUYS the wing {cfg.hedge_offset_normal || 2} strikes out · confirm ×{cfg.confirm_checks || 2} · threshold {cfg.threshold_pct || 10}%
      </div>

      {halt ? (
        <div style={{ ...cardBase, borderColor: 'rgba(239,68,68,0.5)', color: '#f87171', fontSize: 11, marginBottom: 12 }}>
          ☠ SAFETY HALT — {halt}. Check Kite, then press Enable to clear it.
        </div>
      ) : null}
      {st.day_stopped ? (
        <div style={{ ...cardBase, borderColor: 'rgba(251,191,36,0.45)', color: '#fbbf24', fontSize: 11, marginBottom: 12 }}>
          Day stopped — {st.day_stopped}. No further entries today.
        </div>
      ) : null}
      {err ? (
        <div style={{ ...cardBase, borderColor: 'rgba(251,191,36,0.45)', color: '#fbbf24', fontSize: 11, marginBottom: 12 }}>
          OI Ride D LIVE: {err}
        </div>
      ) : null}

      <div style={{ display: 'flex', gap: 10, marginBottom: 12, flexWrap: 'wrap' }}>
        <StatBox label="TOTAL P&L" value={fmtINR(total)} color={total >= 0 ? '#22c55e' : '#ef4444'} />
        <StatBox label="REALIZED" value={fmtINR(st.realized_pnl || 0)} />
        <StatBox label="UNREALIZED" value={fmtINR(st.unrealized_pnl || 0)} />
        <StatBox label="DIRECTION" value={st.direction || '--'} color={dirColor} sub={st.active ? 'in position' : 'flat'} />
        <StatBox label="SIGNAL" value={sig.pct != null ? sig.pct + '%' : '--'} sub={sig.verdict || ''} />
        <StatBox label="NET CREDIT" value={st.entry_premium != null ? String(st.entry_premium) : '--'} />
        <StatBox label="FLIPS" value={st.flips != null ? String(st.flips) : '0'} />
      </div>

      <div style={{ display: 'flex', gap: 12, marginBottom: 12, flexWrap: 'wrap' }}>
        <div style={{ flex: 1.2, minWidth: 340, ...cardBase }}>
          <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1, color: '#556677', marginBottom: 8 }}>
            POSITION {st.atm ? '· ATM ' + st.atm : ''} {st.spot ? '· spot ' + st.spot : ''}
          </div>
          {openLegs.length ? openLegs.map(function (l, i) {
            var isSell = l.side === 'SELL';
            return (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', padding: '6px 0', borderBottom: i === 0 ? '1px solid #131c2b' : 'none', fontSize: 12 }}>
                <span style={{ color: isSell ? '#ef4444' : '#22c55e', fontWeight: 800, minWidth: 44 }}>{l.side}</span>
                <span style={{ flex: 1 }}>{l.strike}{l.type} <span style={{ color: '#6b7a8d', fontSize: 10 }}>{l.role}</span></span>
                <span style={{ color: '#8b98a9', minWidth: 108, textAlign: 'right' }}>{l.entry_price} → {l.ltp}</span>
                <span style={{ minWidth: 84, textAlign: 'right', fontWeight: 800, color: (l.pnl || 0) >= 0 ? '#22c55e' : '#ef4444' }}>{fmtINR(l.pnl || 0)}</span>
              </div>
            );
          }) : (
            <div style={{ fontSize: 11, color: '#6b7a8d', padding: '10px 0' }}>Flat — no open legs.</div>
          )}
          {st.active ? (
            <button onClick={function () { post('/oiride-d-live/exit'); }} disabled={busy}
              style={{ marginTop: 10, fontSize: 11, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', borderRadius: 8, padding: '7px 16px', background: 'rgba(239,68,68,0.12)', color: '#ef4444', border: '1px solid rgba(239,68,68,0.5)' }}>
              Exit now
            </button>
          ) : null}
        </div>

        <div style={{ flex: 1, minWidth: 280, ...cardBase }}>
          <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1, color: '#556677', marginBottom: 8 }}>OI RIDE SIGNAL</div>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, padding: '4px 0' }}>
            <span style={{ color: '#8b98a9' }}>Verdict</span>
            <span style={{ fontWeight: 800, color: sig.verdict === 'LONG' ? '#22c55e' : sig.verdict === 'SHORT' ? '#ef4444' : '#8b98a9' }}>{sig.verdict || '--'}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, padding: '4px 0' }}>
            <span style={{ color: '#8b98a9' }}>Skew</span><span>{sig.pct != null ? sig.pct + '%' : '--'}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, padding: '4px 0' }}>
            <span style={{ color: '#8b98a9' }}>ΔPE / ΔCE</span><span>{sig.dpe != null ? sig.dpe : '--'} / {sig.dce != null ? sig.dce : '--'}</span>
          </div>
          <div style={{ fontSize: 9, color: '#556677', marginTop: 8, lineHeight: 1.5 }}>
            Reversed structure: a LONG read SELLS the ATM call and BUYS the higher one, so the
            position profits when the market falls. Deliberate — it fades the signal.
          </div>
        </div>
      </div>

      <div style={{ ...cardBase, padding: '4px 0' }}>
        <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1, color: '#556677', padding: '8px 14px 4px' }}>EVENTS</div>
        {(st.events || []).length ? st.events.slice().reverse().slice(0, 40).map(function (e, i) {
          var lv = e.level || e.type;
              var c = lv === 'error' ? '#f87171' : lv === 'warning' ? '#fbbf24' : lv === 'success' ? '#22c55e' : '#8b98a9';
          return (
            <div key={i} style={{ display: 'flex', gap: 10, padding: '3px 14px', fontSize: 11, fontFamily: 'ui-monospace, Menlo, monospace' }}>
              <span style={{ color: '#556677', flexShrink: 0 }}>{e.time || e.ts}</span>
              <span style={{ color: c, flex: 1, wordBreak: 'break-word' }}>{e.text || e.msg}</span>
            </div>
          );
        }) : <div style={{ fontSize: 11, color: '#6b7a8d', padding: '10px 14px' }}>No events yet.</div>}
      </div>

      {cfgOpen ? (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(3,7,18,0.75)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50 }}
          onClick={function () { setCfgOpen(false); }}>
          <div onClick={function (e) { e.stopPropagation(); }}
            style={{ ...cardBase, width: 640, maxHeight: '82vh', overflowY: 'auto' }}>
            <div style={{ fontSize: 15, fontWeight: 800, marginBottom: 12 }}>OI Ride D LIVE — settings</div>
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 10 }}>
              <Field label="Lots" value={draft.lots} onChange={D('lots')} />
              <Field label="Product (MIS/NRML)" value={draft.product} onChange={D('product')} />
              <Field label="Entry time" value={draft.entry_time} onChange={D('entry_time')} />
              <Field label="Exit time" value={draft.exit_time} onChange={D('exit_time')} />
            </div>
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 10 }}>
              <Field label="Threshold %" value={draft.threshold_pct} onChange={D('threshold_pct')} />
              <Field label="Confirm checks" value={draft.confirm_checks} onChange={D('confirm_checks')} />
              <Field label="Strikes band" value={draft.strikes_band} onChange={D('strikes_band')} />
              <Field label="Check interval (s)" value={draft.check_interval_sec} onChange={D('check_interval_sec')} />
            </div>
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 10 }}>
              <Field label="Wing offset (normal)" value={draft.hedge_offset_normal} onChange={D('hedge_offset_normal')} />
              <Field label="Wing offset (expiry)" value={draft.hedge_offset_expiry} onChange={D('hedge_offset_expiry')} />
            </div>
            <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: 0.8, color: '#556677', margin: '12px 0 6px' }}>PROFIT MANAGEMENT (₹ per lot, 0 = off)</div>
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 10 }}>
              <Field label="MTM SL" value={draft.mtm_sl_per_lot} onChange={D('mtm_sl_per_lot')} />
              <Field label="Target" value={draft.target_per_lot} onChange={D('target_per_lot')} />
              <Field label="Protect floor" value={draft.protect_per_lot} onChange={D('protect_per_lot')} />
              <Field label="Protect arms at" value={draft.protect_level_per_lot} onChange={D('protect_level_per_lot')} />
              <Field label="Trail step" value={draft.trail_step_per_lot} onChange={D('trail_step_per_lot')} />
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 12 }}>
              <button onClick={function () { setCfgOpen(false); }}
                style={{ fontSize: 12, cursor: 'pointer', fontFamily: 'inherit', borderRadius: 8, padding: '8px 16px', background: 'transparent', color: '#8b98a9', border: '1px solid #26334a' }}>Cancel</button>
              <button onClick={saveCfg}
                style={{ fontSize: 12, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', borderRadius: 8, padding: '8px 20px', background: 'rgba(56,189,248,0.14)', color: '#38bdf8', border: '1px solid rgba(56,189,248,0.5)' }}>Save</button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default OIRideDLive;
